var exports = {
  "uy": "projectActionList__Ux0CXk",
  "lV": "ActionList_LinkItem__93m_TX",
  "z7": "projectItemsContainer__lxowrF",
  "Y4": "projectItemsList__G1WhHz",
  "NL": "overflowProjectItem__u5K44Z",
};

module.exports = exports;
